import * as React from 'react';

function SvgImageIcon(props) {
  return (
    <svg viewBox="0 0 40 37" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M-4-1h48v48H-4z" />
        <path
          d="M2.285 24.575v8.482c0 1.197.976 2.171 2.177 2.171h25.971M24.883 5.99L28.868.174l-.195 7.047 6.641-2.363-4.3 5.587 6.763 1.992-6.763 1.992 4.3 5.586-6.641-2.363.195 7.047-3.985-5.816L20.9 24.7l.195-7.047-6.642 2.363 4.3-5.586-6.762-1.992 6.762-1.992-4.3-5.587 6.642 2.363L20.9.174l3.984 5.816"
          fill="#FBCE20"
        />
        <path
          d="M20.009 20.137a3.223 3.223 0 00-3.22 3.22 3.224 3.224 0 003.22 3.22 3.223 3.223 0 003.22-3.22 3.223 3.223 0 00-3.22-3.22zm0 8.18a4.966 4.966 0 01-4.96-4.96 4.966 4.966 0 014.96-4.96 4.966 4.966 0 014.961 4.96 4.966 4.966 0 01-4.961 4.96z"
          fill="#4D4E4C"
        />
        <path
          d="M20.009 16.716a6.648 6.648 0 00-6.64 6.64 6.648 6.648 0 006.64 6.642 6.648 6.648 0 006.64-6.641 6.648 6.648 0 00-6.64-6.64zm0 15.023c-4.622 0-8.382-3.76-8.382-8.382s3.76-8.382 8.382-8.382 8.382 3.76 8.382 8.382c0 4.621-3.76 8.382-8.382 8.382z"
          fill="#4D4E4C"
        />
        <path
          d="M4.83 11.706a2.548 2.548 0 00-2.545 2.545v17.788a2.548 2.548 0 002.545 2.546h30.358a2.548 2.548 0 002.545-2.546V14.251a2.548 2.548 0 00-2.545-2.545H4.83zm30.358 24.62H4.83a4.291 4.291 0 01-4.287-4.287V14.251A4.291 4.291 0 014.83 9.965h30.358a4.291 4.291 0 014.287 4.286v17.788a4.291 4.291 0 01-4.287 4.287z"
          fill="#4D4E4C"
        />
        <path
          d="M14.992 10.75H13.24V9.514a.655.655 0 00-.653-.654H7.2a.655.655 0 00-.654.654v1.238H4.795V9.513A2.408 2.408 0 017.2 7.108h5.387a2.408 2.408 0 012.405 2.405v1.238"
          fill="#4D4E4C"
        />
      </g>
    </svg>
  );
}

export default SvgImageIcon;
